import { Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { BoardOfDirectorsPageContent } from "./BoardOfDirectorsPageContent";
import { BoardOfDirectorsPageHeading } from "./BoardOfDirectorsPageHeading";
import { NextPage } from "./NextPage";

export const BoardOfDirectors = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();
  const items = [
    {
      label: "Page Heading",
      key: "boardOfDirectorsPageHeading",
      children: <BoardOfDirectorsPageHeading />,
    },
    {
      label: "Page Content",
      key: "boardOfDirectorsPageContent",
      children: <BoardOfDirectorsPageContent />,
    },

    {
      label: "Next Page",
      key: "boardOfDirectorsNextPage",
      children: <NextPage />,
    },
  ];

  return (
    <>
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get("activeTab")}&subActiveTab=${activeKey}`);
        }}
      ></Tabs>
    </>
  );
};
